import { FC } from 'react';
import theme from '../../../theme';
import Icon from '../Icon';

interface Props {
  width?: string;
  /** A theme colour name (e.g. 'primary') or any CSS colour. */
  color?: string;
}

const SuccessIcon: FC<Props> = ({ width = '24', color }) => (
  <Icon
    name="success"
    size={Number(width) || width}
    color={(theme.colors.general as Record<string, string>)[color] || color || theme.colors.general.success}
  />
);

export default SuccessIcon;
